import { Injectable } from "@angular/core";
import { DataListModel, IAPIResponse, WeGoConfig } from "../../shared/config";
import { Observable } from "rxjs/Observable";
import { RequestOptions, Http, ResponseContentType } from "@angular/http";
import { JQueryHelperService } from "../../shared/models/jquery-helper.service";
import { AuthService } from "../../shared/models/auth.service";
import { CostCenterReportFilter } from "./report-filter-cost-center.model";

@Injectable()
export class CostCenterReportService {
  private JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) { }

  public GetCostTypeList(
    instanceHashId?: string,
    pageName: string = ""
  ): Observable<IAPIResponse> {
    let getCostTypeListUrl: string;
    switch (pageName) {
      case "Cost_Center_Report":
        getCostTypeListUrl =
          WeGoConfig.API_GET_COST_TYPE_LIST_FOR_COST_CENTER_REPORT;
        break;

      default:
        getCostTypeListUrl =
          WeGoConfig.API_GET_COST_TYPE_LIST_FOR_COST_CENTER_REPORT;
        break;
    }

    if (instanceHashId)
      getCostTypeListUrl =
        getCostTypeListUrl + "?instanceHashId=" + instanceHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCostTypeListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetCostCenterReportData(
    input: CostCenterReportFilter
  ): Observable<IAPIResponse> {
    let body = input;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_GET_COST_CENTER_REPORT_DATA, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportCostCenterReportExcel(model: CostCenterReportFilter): any {
    let getUrl = WeGoConfig.API_EXPORT_COST_CENTER_REPORT_EXCEL;
    let queryStringReportFilterModel = this.JQueryHelper.Param(model);
    getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);

    let headers = this.authService.GetHeader(
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );
    let options = new RequestOptions({
      headers: headers,
      responseType: ResponseContentType.Blob
    });
    return this.http.get(getUrl, options);
  }

  public ExportCostCenterReportPdf(model: CostCenterReportFilter): any {
    let getUrl = WeGoConfig.API_EXPORT_COST_CENTER_REPORT_PDF;
    let queryStringReportFilterModel = this.JQueryHelper.Param(model);
    getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);

    let headers = this.authService.GetHeader('application/pdf');
    let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
    return this.http.get(getUrl, options);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/models/cost-center-report.service.ts